import React from "react";
import {Select, Space, Switch} from "antd";

const TipS2P = ({t, isS2pTip, s2pDefaultTipPercent, onChange}) => {
    const onIsTipS2PChange = (checked) => {
        // When the switch changes, update isS2pTip and keep the current percentage
        onChange({
            isS2pTip: checked,
            s2pDefaultTipPercent: s2pDefaultTipPercent,
        })
    }

    const onTipPercentChange = (value) => {
        // When the select changes, update s2pDefaultTipPercent and keep the current switch state
        onChange({
            isS2pTip: isS2pTip,
            s2pDefaultTipPercent: Number(value),
        })
    }

    return (
        <>
            <div className="form-group">
                <label htmlFor="sms">{t("pages.user.profile.label14")}</label>
                <Space>
                    <Switch
                        id="scan2pat-tip"
                        checked={isS2pTip} // Use 'checked' for boolean value [^2]
                        onChange={onIsTipS2PChange}
                        checkedChildren={t("common.onStatus")}
                        unCheckedChildren={t("common.offStatus")}
                        style={{backgroundColor: isS2pTip ? "var(--color-status-on)" : "var(--color-status-off)"}}
                    />
                    {
                        isS2pTip && ( // Only show the select if the switch is on
                            <Select
                                defaultValue={String(s2pDefaultTipPercent)}
                                style={{width: 120}}
                                onChange={onTipPercentChange}
                                options={[
                                    {value: 0, label: "0%"},
                                    {value: 5, label: "5%"},
                                    {value: 10, label: "10%"},
                                    {value: 15, label: "15%"},
                                    {value: 20, label: "20%"},
                                ]}
                            />
                        )
                    }
                </Space>
            </div>
        </>
    )
}

export default TipS2P;
